import { get } from 'lodash'

export function mapCountries(fields) {
  return fields && Array.isArray(fields)
    ? fields.map(item => ({
        label: item.name,
        value: item.id
      }))
    : []
}

export function map(fields) {
  return fields && Array.isArray(fields)
    ? fields.map(item => ({
        label: item.name,
        value: item.id
      }))
    : []
}

export function mapAwards(fields) {
  return fields && Array.isArray(fields)
    ? fields.map(item => ({
        label: get(item, 'translationText'),
        value: get(item, 'value')
      }))
    : []
}

export function mapCodeList(fields) {
  return fields && Array.isArray(fields)
    ? fields.map(item => ({
        label: item.textTranslated,
        value: item.value
      }))
    : []
}

export function mapCategories(fields) {
  return fields && Array.isArray(fields)
    ? fields.map(item => ({
        label: item.translatedName,
        value: item.id
      }))
    : []
}
